var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBlockHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 68,
    viewBox: "0 0 119 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BLOC HAND"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON HANDS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.4272 55.2517L56.9382 52.5981C58.0612 52.3141 59.2523 52.5708 60.1648 53.2911C62.6191 55.2513 67.5297 59.1789 69.4418 60.769C72.0321 62.9181 75.5966 59.8183 77.2443 57.8144",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M70.1963 50.817L78.6456 57.6341C79.0161 57.9313 79.4239 58.1726 79.8613 58.3301C81.389 58.8707 84.7906 59.3785 87.5514 54.7036",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M75.6582 45.4161L86.3285 53.4949C86.3285 53.4949 91.9995 58.329 96.1533 50.6325",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M83.5891 40.5425L94.665 49.2868C94.665 49.2868 98.3075 52.0339 100.3 49.2607C100.3 49.2607 101.292 48.2947 101.742 47.3067C102.382 45.9176 102.379 44.2319 100.844 42.907C99.2105 41.5034 77.0923 22.1072 77.0923 22.1072C77.0923 22.1072 73.6169 19.5251 71.1671 23.8785C68.2828 29.0039 65.3499 33.1446 65.3499 33.1446C65.3499 33.1446 62.7273 37.259 57.5331 34.8856C53.4755 33.0336 57.7263 26.0889 57.7263 26.0889L62.7945 14.9299C62.7945 14.9299 63.9122 11.4105 71.8736 9.40225C79.835 7.39397 82.4723 10.0895 82.4723 10.0895L92.405 12.748C93.5747 13.0636 94.8113 13.0503 95.9807 12.7156L108.026 9.24702",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M38.6461 27.4422L48.0445 24.8126C50.2468 24.1964 52.3499 23.2525 54.2695 22.0044L61.4014 18.1939",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M113.567 36.1328L98.0396 40.3716",
    stroke: "#EF7056",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "ICON LINES"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.3368 39.8895L24.5174 37.0978",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.7975 9.95318L26.5378 16.1117",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M23.23 27.6216L4.89596 24.5977",
    stroke: "#EF7056",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlockHand);
export default __webpack_public_path__ + "static/media/icon-block-hand.c395420d9e48cf02d5e4098ac25be360.svg";
export { ForwardRef as ReactComponent };